const { SITE_BASE_URL } = require('./brokerConnectionSource');

function escapeXml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

function ogSlugForPath(pathname) {
  if (!pathname || pathname === '/') return 'home';
  return String(pathname)
    .replace(/^\//, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80) || 'page';
}

function ogImageUrlForPath(pathname, baseUrl = SITE_BASE_URL) {
  return `${baseUrl}/og/${ogSlugForPath(pathname)}.svg`;
}

function wrapTitleLines(title, maxChars = 28, maxLines = 4) {
  const words = String(title || 'BotSpot')
    .replace(/\s+\|\s+BotSpot.*$/i, '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  const lines = [];
  let current = '';
  words.forEach((word) => {
    const next = current ? `${current} ${word}` : word;
    if (next.length > maxChars && current) {
      lines.push(current);
      current = word;
    } else {
      current = next;
    }
  });
  if (current) lines.push(current);
  return lines.slice(0, maxLines);
}

function buildOgTitleCardSvg({ title, eyebrow = 'BotSpot' } = {}) {
  const lines = wrapTitleLines(title);
  const startY = lines.length <= 2 ? 292 : 250;
  const renderedLines = lines.map((line, index) => (
    `<text x="88" y="${startY + (index * 64)}" fill="#F7F4EC" font-family="Arial, Helvetica, sans-serif" font-size="52" font-weight="700">${escapeXml(line)}</text>`
  )).join('');

  return [
    '<?xml version="1.0" encoding="UTF-8"?>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="630" viewBox="0 0 1200 630" role="img">',
    `<title>${escapeXml(title || 'BotSpot')}</title>`,
    '<rect width="1200" height="630" fill="#07111C"/>',
    '<rect x="0" y="0" width="18" height="630" fill="#F5B942"/>',
    `<text x="88" y="118" fill="#F5B942" font-family="Arial, Helvetica, sans-serif" font-size="28" font-weight="700" letter-spacing="4">${escapeXml(String(eyebrow).toUpperCase())}</text>`,
    renderedLines,
    '<text x="88" y="548" fill="#C8D0DA" font-family="Arial, Helvetica, sans-serif" font-size="26">botspot.trade</text>',
    '</svg>',
    '',
  ].join('');
}

module.exports = {
  buildOgTitleCardSvg,
  ogImageUrlForPath,
  ogSlugForPath,
};
